import { InputTypes } from './form.model';

export interface PaymentMethodCategory {
  id: string;
  name: string;
  label: string;
}

export interface InputMetaData {
  pattern?: string;
  errorMessage?: string;
  preprocessed?: boolean;
  scale?: number;
  options?: { value: string; label: string }[];
  min?: number;
  max?: number;
  step?: string | null;
  currency?: string; //@TODO: domain specific name (the config should be generic)
  isUiOnly?: boolean;
  yearFormat?: 'YY' | 'YYYY'; //@TODO: domain specific name (the config should be generic)
  prefix?: string;
}

export interface PaymentFormField {
  name: string;
  required: boolean;
  type: InputTypes;
  value: string | number | boolean | null;
  label?: string;
  placeholder?: string;
  mask?: string;
  params?: InputMetaData;
  isDisabled?: boolean;
}

export enum IntegrationSources {
  Internal = 'internal',
  External = 'external',
}

export interface RuleConfiguration {
  min: number | null;
  max: number | null;
  recommended: boolean;
  amounts: string[];
  step: string | null;
}

export interface PaymentMethodRestriction {
  type: string;
  message: string;
}

//@TODO: maybe it would be more effective to use enum instead
export type NextStepType = 'display' | 'html' | 'form' | 'redirect';
export type NextStepContainer = 'window' | 'iframe';

export interface NextStep {
  nullable: boolean;
  types: NextStepType[];
  containers: NextStepContainer[];
}

export interface NextStepInfo {
  post_process: null | NextStep;
  post_confirm: null | NextStep;
  channel: null | NextStep;
}

export enum PreprocessorTypes {
  ENCRYPTOR_V1 = 'encryptor_v1',
  PAYLOAD_ENRICHER_V1 = 'payload_enricher_v1',
  SDK_PROCESSOR_V1 = 'sdk_processor_v1',
  ENCRYPTOR_V2 = 'encryptor_v2',
  TOKENIZER_V1 = 'tokenizer_v1',
}

export interface TokenizerV1PreprocessorParameters {
  preprocessorUrl: string;
  password: string;
  username: string;
}

export interface EncryptorPreprocessorParameters {
  preprocessorUrl: string;
  paymentIqMerchantId: string;
}

export interface SdkProcessorPreprocessorParameters {
  pspMerchantId: string;
  preprocessorUrl: string;
}

export interface PreprocessorConfiguration {
  type: PreprocessorTypes;
  parameters:
    | EncryptorPreprocessorParameters
    | TokenizerV1PreprocessorParameters
    | SdkProcessorPreprocessorParameters;
}

export interface PaymentMethodBase {
  id: string;
  name: string;
  categories: string[];
  recommended: boolean;
  logo: string;
  order?: number;
}

export enum RedirectContainers {
  NO_REDIRECT = 'NO_REDIRECT',
  IFRAME = 'IFRAME',
  NEW_TAB = 'NEW_TAB',
}

export interface PaymentMethodConfiguration {
  id: string;
  name: string;
  vendor: string;
  referenceId: string;
  activeInputs: PaymentFormField[];
  account_form_inputs: PaymentFormField[];
  inputs: PaymentFormField[];
  categories: PaymentMethodCategory[];
  ruleParams: RuleConfiguration;
  description?: string;
  source: IntegrationSources | null;
  preprocessor: PreprocessorConfiguration | null;
  logo: string;
  //TODO: rename fields to camelCase analogues
  display_form_description?: string;
  final_screen_description?: string;
  next_step_info: NextStepInfo;
  show_account_form?: boolean;
  redirectContainer: RedirectContainers;
  restriction?: PaymentMethodRestriction | null;
}
